import { useState } from "react";
import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import { Users } from "lucide-react";

import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/common";
import {
  useUserListDerived,
  useUserListPageEffects,
  useUserStore,
} from "../hooks";
import UserTable from "../components/UserTable";
import CreateUserDialog from "../components/CreateUserDialog";
import UserViewDialog from "../components/UserViewDialog";
import DeleteUserDialog from "../components/DeleteUserDialog";

const UserListContent = observer(() => {
  const { t } = useTran();
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [viewDialogUser, setViewDialogUser] = useState(null);
  const [deleteDialogUser, setDeleteDialogUser] = useState(null);

  useUserListPageEffects();
  const { isAdminRole } = useUserListDerived();
  const { canCreateUser, canCreateUserMessage } = useUserStore();

  const isAllowedToCreateUser = isAdminRole || canCreateUser;

  return (
    <div className="space-y-6">
      <PageHeader
        title={t("Users")}
        description={t(
          "Manage users, roles, follow-ups, and onboarding in one place.",
        )}
        icon={Users}
        actions={
          <>
            <Button
              type="button"
              size="sm"
              disabled={!isAllowedToCreateUser}
              onClick={() => setCreateDialogOpen(true)}
            >
              {t("Create User")}
            </Button>
            {!isAdminRole && !canCreateUser && canCreateUserMessage ? (
              <span className="text-xs text-destructive text-right max-w-[220px]">
                {canCreateUserMessage}
              </span>
            ) : null}
          </>
        }
      />

      <UserTable
        onViewUser={setViewDialogUser}
        onDeleteUser={setDeleteDialogUser}
      />
      <CreateUserDialog
        open={createDialogOpen}
        onOpenChange={setCreateDialogOpen}
      />
      <UserViewDialog
        user={viewDialogUser}
        onClose={() => setViewDialogUser(null)}
      />
      <DeleteUserDialog
        user={deleteDialogUser}
        onClose={() => setDeleteDialogUser(null)}
      />
    </div>
  );
});

const UserListPage = () => <UserListContent />;

export default UserListPage;
